import { device } from '@accedo/xdk-core'
import { redirectHandler } from '../../lib/routes'
import { getTizenDeeplinkPath } from '../../utils/deeplinkUtils'

export class TizenSettings implements DeviceSettings {
  public init() {
    window.addEventListener('appcontrol', () => {
      const deeplink = getTizenDeeplinkPath()

      if (deeplink) {
        redirectHandler(deeplink)
      }
    })
  }

  public getCaptionState() {
    try {
      return window?.tizen?.tvinfo?.getCaptionValue('CAPTION_ONOFF_KEY') === 'CAPTION_ON'
    } catch (e) {
      console.error('Unable to get caption state from device: ', e)
      return false
    }
  }

  public addCaptionChangeEventListener(cb) {
    try {
      const listenerId = window?.tizen?.tvinfo?.addCaptionValueChangeListener(
        'CAPTION_ONOFF_KEY',
        function (value) {
          cb(value)
        },
      )

      return listenerId
    } catch (e) {
      console.warn('Unable to set caption change listener on device: ', e)

      cb(false)

      return -1
    }
  }

  public removeCaptionChangeEventListener() {
    try {
      const tvInfo = window?.tizen?.tvinfo
      const listenerId = tvInfo?.addCaptionValueChangeListener('CAPTION_ONOFF_KEY', function () {})

      tvInfo?.removeCaptionValueChangeListener(listenerId)
    } catch (e) {
      console.warn('Unable to remove caption change listener: ', e)
    }
  }

  public getVoiceState() {
    try {
      const tvInfo = window?.webapis?.tvinfo
      const voiceGuideKey = tvInfo?.TvInfoMenuKey?.VOICE_GUIDE_KEY
      const isTtsOn = tvInfo?.getMenuValue(voiceGuideKey) === 1

      return isTtsOn
    } catch (e) {
      console.warn('Unable to get voice state on device: ', e)
      return false
    }
  }

  public addVoiceChangeEventListener(cb) {
    try {
      const tvInfo = window?.webapis?.tvinfo
      const voiceGuideKey = tvInfo?.TvInfoMenuKey?.VOICE_GUIDE_KEY

      const listenerId = tvInfo?.addCaptionChangeListener(voiceGuideKey, function () {
        const isTtsOn = tvInfo?.getMenuValue(voiceGuideKey) === 1
        cb(isTtsOn)
      })

      return listenerId
    } catch (e) {
      console.warn('Unable to set voice change listener: ', e)

      cb(false)

      return -1
    }
  }

  public removeVoiceChangeEventListener() {
    try {
      const tvInfo = window?.webapis?.tvinfo
      const voiceGuideKey = tvInfo?.TvInfoMenuKey?.VOICE_GUIDE_KEY

      const listenerId = tvInfo?.addCaptionChangeListener(voiceGuideKey, function () {})

      tvInfo?.removeCaptionChangeListener(listenerId)
    } catch (e) {
      console.warn('Unable to remove voice change listener: ', e)
    }
  }

  public async getModel(): Promise<DeviceModel> {
    let model = {
      id: null,
      name: 'Tizen',
      type: 'TV',
      version: null,
    }

    try {
      model = {
        ...model,
        id: await device.system.getUniqueId(),
        name: device.system.getModel(),
        version: device.system.getFirmwareVersion(),
        type: tizen.systeminfo.getCapability('http://tizen.org/system/device_type'),
      }
    } catch (e) {
      console.error('There was a problem capturing the model context data. Details:', e)
    }

    return model
  }

  public getOS(): DeviceOS {
    let os = {
      name: '',
      version: '',
    }
    try {
      os = {
        name: 'tizen',
        version: tizen.systeminfo.getCapability('http://tizen.org/feature/platform.version'),
      }
    } catch (e) {
      console.error('There was a problem capturing the os context data. Details:', e)
    }

    return os
  }

  public getVendor(): string {
    return 'Samsung'
  }

  public getAppStoreURL(): string {
    return 'https://samsung.com/us/appstore/app/G20250600048'
  }

  public getAppIDForAds(): string {
    return 'G20250600048'
  }

  public getDeviceYear(): number {
    return device.system.getDeviceYear()
  }

  public getRDID(): string {
    try {
      return webapis.adinfo.getTIFA()
    } catch (e) {
      console.warn('Unable to get RDID information: ', e)
    }

    return ''
  }

  public isLATEnabled(): boolean {
    try {
      return webapis.adinfo.isLATEnabled()
    } catch (e) {
      console.warn('Unable to get LAT information: ', e)
    }

    return false
  }
}
